import styled from 'styled-components'

export const TestPageWrapper = styled.div`
  background-color: ${props => props.backgroundColor};
  padding: 16px;
`